/*
 * Module for the SPC Possible Missing Payments criteria page
 */
rs.module("content/reports/spcpossiblemissingpaymentscriteria",

    ["common/select-helper"],

    function (selectHelper) {    

        // Initialize the page
        function initialize(jsSelectors, backendUrl) {

            var criteria = $.js(jsSelectors.criteria);

            var planSelect = criteria.js(jsSelectors.planSelect);
            var employerSelect = criteria.js(jsSelectors.employerSelect);

            var planNameHidden = criteria.js(jsSelectors.planNameHidden);
            var employerNameHidden = criteria.js(jsSelectors.employerNameHidden);

            // Get Select Helper for employerSelect since we're updating its options and properties
            var employerSelectHelper = selectHelper.getHelper(employerSelect);

            planSelect.change(planChanged);
            employerSelect.change(employerChanged);

            // On plan selection change, retrieve and populate employer drop down
            function planChanged() {

                // load employers based on plan selection (all or specific)
                var selectedPlanKey = planSelect.val();

                if (selectedPlanKey == "") {
                    employerSelectHelper.loadOptionsFrom(backendUrl, null, { withBlank: true });
                }
                else {
                    employerSelectHelper.loadOptionsFrom(backendUrl, { planKey: selectedPlanKey }, { withBlank: true });
                }

                //Set Hidden Fields (PlanName and EmployerName) based on selected values
                planNameHidden.val(planSelect.find(":selected").text());
                employerNameHidden.val(employerSelect.find(":selected").text());
            }

            // On employer selection change, set Hidden Field (EmployerName) based on on selected value
            function employerChanged() {
                employerNameHidden.val(employerSelect.find(":selected").text());
            }
        }

        var exports = {
            initialize: initialize
        };

        return exports;
    }
);